module.exports = __webpack_public_path__ + "static/media/controller.5a1dc357.png";